/* TO BE REFACTORED */

export const SET_INSTRUCTORS = "SET_INSTRUCTORS";

export const HANDLE_FETCH_INSTRUCTOR_SUMMARY = "HANDLE_FETCH_INSTRUCTOR_SUMMARY";
export const SET_INSTRUCTOR_SUMMARY = "SET_INSTRUCTOR_SUMMARY";

/* NEW */

export const HANDLE_FETCH_INSTRUCTORS = "HANDLE_FETCH_INSTRUCTORS";
export interface IHandleFetchInstructors {
  type: typeof HANDLE_FETCH_INSTRUCTORS;
}
export const HANDLE_FETCH_INSTRUCTOR_STUDENTS = "HANDLE_FETCH_INSTRUCTOR_STUDENTS";
export interface IHandleFetchInstructorStudents {
  type: typeof HANDLE_FETCH_INSTRUCTOR_STUDENTS;
}

export const HANDLE_DEACTIVATE_INSTRUCTOR = "HANDLE_DEACTIVATE_INSTRUCTOR";

export interface IHandleDeactivateInstructor {
  type: typeof HANDLE_DEACTIVATE_INSTRUCTOR;
  payload: DeactivateInstructorRequest;
  source: UpdateSource;
}
export const HANDLE_ARCHIVE_INSTRUCTOR = "HANDLE_ARCHIVE_INSTRUCTOR";

export interface IHandleArchiveInstructor {
  type: typeof HANDLE_ARCHIVE_INSTRUCTOR;
  payload: ArchiveInstructorRequest;
  source: UpdateSource;
}

export const SET_INSTRUCTOR_STUDENTS = "SET_INSTRUCTOR_STUDENTS";

export interface ISetInstructorStudents {
  type: typeof SET_INSTRUCTOR_STUDENTS;
  payload: Student[];
}

export const HANDLE_FETCH_INSTRUCTOR = "HANDLE_FETCH_INSTRUCTOR";
export interface IHandleFetchInstructor {
  type: typeof HANDLE_FETCH_INSTRUCTOR;
  instructorId: string;
}

export const HANDLE_CREATE_INSTRUCTOR = "HANDLE_CREATE_INSTRUCTOR";

export interface IHandleCreateInstructor {
  type: typeof HANDLE_CREATE_INSTRUCTOR;
  payload: CreateInstructorRequest;
}

export const HANDLE_UPDATE_INSTRUCTOR_INFO = "HANDLE_UPDATE_INSTRUCTOR_INFO";
export interface IHandleUpdateInstructorInfo {
  type: typeof HANDLE_UPDATE_INSTRUCTOR_INFO;
  payload: UpdateInstructorInfoRequest;
}
export const HANDLE_UPDATE_INSTRUCTOR_ADDRESS = "HANDLE_UPDATE_INSTRUCTOR_ADDRESS";

export interface IHandleUpdateInstructorAddress {
  type: typeof HANDLE_UPDATE_INSTRUCTOR_ADDRESS;
  payload: UpdateInstructorAddressRequest;
}

export const HANDLE_UPDATE_INSTRUCTOR = "HANDLE_UPDATE_INSTRUCTOR";

export interface IHandleUpdateInstructor {
  type: typeof HANDLE_UPDATE_INSTRUCTOR;
  payload: UpdateInstructor;
}

export const HANDLE_FETCH_INSTRUCTOR_CLASSROOMS = "HANDLE_FETCH_INSTRUCTOR_CLASSROOMS";

export interface IHandleFetchInstructorClassrooms {
  type: typeof HANDLE_FETCH_INSTRUCTOR_CLASSROOMS;
  payload: string;
}

export const SET_INSTRUCTOR_CLASSROOMS = "SET_INSTRUCTOR_CLASSROOMS";

export interface ISetInstructorClassrooms {
  type: typeof SET_INSTRUCTOR_CLASSROOMS;
  payload: Classroom[];
}

export const HANDLE_FETCH_INSTRUCTOR_STATS = "HANDLE_FETCH_INSTRUCTOR_STATS";
export interface IHandleFetchInstructorStats {
  type: typeof HANDLE_FETCH_INSTRUCTOR_STATS;
  payload: string;
}

export const SET_INSTRUCTOR_STATS = "SET_INSTRUCTOR_STATS";

export interface ISetInstructorStats {
  type: typeof SET_INSTRUCTOR_STATS;
  payload: {
    instructorStats: InstructorStats;
    instructorId: string;
  };
}

export const HANDLE_ADD_INSTRUCTOR_LOCATION = "HANDLE_ADD_INSTRUCTOR_LOCATION";

export interface IHandleAddInstructorLocation {
  type: typeof HANDLE_ADD_INSTRUCTOR_LOCATION;
  payload: AddInstructorLocation;
}

export const HANDLE_REMOVE_INSTRUCTOR_LOCATION = "HANDLE_REMOVE_INSTRUCTOR_LOCATION";

export interface IHandleRemoveInstructorLocation {
  type: typeof HANDLE_REMOVE_INSTRUCTOR_LOCATION;
  payload: RemoveInstructorLocation;
}

export const HANDLE_GRANT_FULL_ACCESS = "HANDLE_GRANT_FULL_ACCESS";

export interface IGrantFullAccess {
  type: typeof HANDLE_GRANT_FULL_ACCESS;
  payload: FullAccessToOrganizationRequest;
}

export const HANDLE_REVOKE_FULL_ACCESS = "HANDLE_REVOKE_FULL_ACCESS";

export interface IRevokeEFullAccess {
  type: typeof HANDLE_REVOKE_FULL_ACCESS;
  payload: FullAccessToOrganizationRequest;
}

export const SET_INSTRUCTOR = "SET_INSTRUCTOR";

export interface ISetInstructor {
  type: typeof SET_INSTRUCTOR;
  payload: Instructor;
}

export const SET_INSTRUCTORS_SIMPLIFIED_LOADING = "SET_INSTRUCTORS_SIMPLIFIED_LOADING";

export interface ISetInstructorsSimplifiedLoading {
  type: typeof SET_INSTRUCTORS_SIMPLIFIED_LOADING;
  payload: {
    isLoading: boolean;
  };
}
